import { Box, Typography } from "@mui/material"
import React, { useCallback, useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { customPalette } from "../../../../../../../../../theme"
import { CustomBottomNavigation } from "../../../../../../../../components/buttons/navigate-button/CustomBottomNavigation"
import { IconInbox } from "../../../../../../../../components/custom-icons/icon-inbox"
import { SuccessContext } from "../../../../../../../../components/layout/success-snackbar"
import { pagesUrl } from "../../../../../../../../core/appConstants"
import { AppSideBarContext } from "../../../../../../../../core/context/AppSideBarContext/AppSideBarContext"
import { BSInputContext } from "../../../../../../../../core/context/beem-shot/BSInput/BSInputContext"
import { BSVariantContext } from "../../../../../../../../core/context/beem-shot/BSVariant/BSVariantContext"
import { AppNavBarContext, NavbarTypeEnum } from "../../../../../../../../core/context/nav-bar/AppNavBarContext"
import { CoverImgProjectContext } from "../../../../../../../../core/context/project/CoverImgProjectContext"
import { ProjectContext } from "../../../../../../../../core/context/project/ProjectContext"
import { FoundationTypeEnum, foundationTypeEnum } from "../../../../../../../../core/enum/beem-shot/FoundationTypeEnum"
import { useForm } from "../../../../../../../../core/hooks/form/use-form"
import { required } from "../../../../../../../../core/hooks/form/validation"
import { enumToSelectOptions } from "../../../../../../../../core/services/helper-service"
import { resolveUrl } from "../../../../../../../../core/services/http-service"
import {
  bsInputFondationDtoToForm,
  formToBSInputFondationUpdateDto,
  IBSInputFondationForm,
} from "../../../tabs/BSBuildingTabs/BSBuildingFondationTab/BSBuildingFondationTab"
import { BSBuildingFondationForm } from "../../../tabs/BSBuildingTabs/BSBuildingFondationTab/components/BSBuildingFondationForm"
import { BSMorphologyContext } from "../../../tabs/BSBuildingTabs/BSBuildingMorphologyTab/context/BSMorphologyContext"
import { BSBuildingContext } from "../../components/context/BSBuildingContext"

export function BSBuildingFondationPage(): React.JSX.Element {
  const navigate = useNavigate()

  const { setShowAppSide, setFullScreen } = useContext(AppSideBarContext)
  const { setTypeNavBar, setImageFile, setIcon, setTitle, setPreviousUrl, setStepHeader } = useContext(AppNavBarContext)
  const { file } = useContext(CoverImgProjectContext)
  const { project } = useContext(ProjectContext)
  const { selectedVariant } = useContext(BSVariantContext)
  const { selectedBSBuilding } = useContext(BSBuildingContext)
  const { bsInput, updateBSInputFoundationType } = useContext(BSInputContext)
  const openSuccessSnackbar = useContext(SuccessContext)
  const { startEstimatingMorphology, bsMorphology } = useContext(BSMorphologyContext)

  useEffect(() => {
    setTypeNavBar(NavbarTypeEnum.BUILDING_HEADER)
    setImageFile(file)
    setIcon(<IconInbox sx={{ color: customPalette.black, fontWeight: "2px" }} />)
    setTitle(selectedVariant?.name ?? "")
    setFullScreen(false)
    if (selectedBSBuilding?.bim !== true) {
      setStepHeader(5)
      setPreviousUrl(resolveUrl(pagesUrl.BUILDING_PATIO, [project?.id, selectedVariant?.id, selectedBSBuilding?.id]))
    } else {
      setStepHeader(4)
      setPreviousUrl(
        resolveUrl(pagesUrl.BUILDING_ZONE_AND_LEVEL, [project?.id, selectedVariant?.id, selectedBSBuilding?.id])
      )
    }
  }, [
    file,
    project?.id,
    selectedBSBuilding?.bim,
    selectedBSBuilding?.bsBimModelId,
    selectedBSBuilding?.id,
    selectedVariant?.id,
    selectedVariant?.name,
    setFullScreen,
    setIcon,
    setImageFile,
    setPreviousUrl,
    setStepHeader,
    setTitle,
    setTypeNavBar,
  ])

  useEffect(() => {
    setShowAppSide(false)
  }, [setShowAppSide])

  const submit: (form: IBSInputFondationForm) => Promise<any> = useCallback(
    (form) => {
      if (project && selectedVariant && bsInput) {
        return updateBSInputFoundationType(formToBSInputFondationUpdateDto(form, bsInput.id))
          .then(() => {
            if (selectedBSBuilding?.id && !selectedBSBuilding.bim) {
              startEstimatingMorphology(selectedBSBuilding?.id)
            }
          })
          .then(() => {
            openSuccessSnackbar("Les fondations ont été mises à jour.")

            navigate(
              selectedBSBuilding?.bim
                ? resolveUrl(pagesUrl.CALCUL, [
                    project?.id,
                    selectedBSBuilding?.bsVariantId,
                    selectedBSBuilding?.id,
                    selectedBSBuilding?.bsBimModelId,
                  ])
                : resolveUrl(pagesUrl.CALCUL_MORPHOLOGY, [
                    project?.id,
                    selectedBSBuilding?.bsVariantId,
                    selectedBSBuilding?.id,
                    bsMorphology?.id,
                  ])
            )
          })
      }
      return Promise.resolve()
    },
    [
      project,
      selectedVariant,
      bsInput,
      updateBSInputFoundationType,
      selectedBSBuilding,
      startEstimatingMorphology,
      openSuccessSnackbar,
      navigate,
      bsMorphology?.id,
    ]
  )

  const { form, errors, handleChange, handleSubmit, isSubmitting } = useForm(
    bsInput,
    bsInputFondationDtoToForm,
    [required("typeFondation")],
    submit
  )

  return (
    <Box
      component="form"
      id="update-bs-building-fondations"
      onSubmit={handleSubmit}
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      gap={2}>
      <Typography variant="h5" fontWeight={600} p={3}>
        Renseigner les fondations du bâtiment
      </Typography>

      <Box width="70%">
        <BSBuildingFondationForm
          title="Fondations"
          id="typeFondation"
          label="Type de fondations"
          selectedOption={form.typeFondation}
          options={enumToSelectOptions(FoundationTypeEnum, foundationTypeEnum)}
          handleChange={handleChange}
          errors={errors}
        />
      </Box>

      <CustomBottomNavigation actionLabel="Enregistrer" formId="update-bs-building-fondations" isSubmitting={isSubmitting} />
    </Box>
  )
}
